// extracted by mini-css-extract-plugin
export default {"text":"addon_text__LTcoY","append":"addon_append__vBo8X","prepend":"addon_prepend__9eddw","label":"addon_label__A6auO","pointer":"addon_pointer__Qbzp1"};